import { OnboardingModeEnum } from 'modules/onboarding/types/onboarding-mode.enum';
import { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOnboardingStore } from 'shared/hooks/stores/useOnboardingStore';
import { useSitemap } from 'shared/hooks/useSitemap';
import { useShallow } from 'zustand/react/shallow';

interface AutoOnboardingPathProps {
  element: ReactNode;
}

export const AutoOnboardingPath: FC<AutoOnboardingPathProps> = ({ element }) => {
  const sitemap = useSitemap();

  const { mode, finishedAt } = useOnboardingStore(
    useShallow((state) => ({
      mode: state.mode,
      finishedAt: state.finishedAt,
    })),
  );

  const shouldRedirectToOnboarding = !finishedAt && mode !== OnboardingModeEnum.Auto;
  if (shouldRedirectToOnboarding) {
    return <Navigate to={sitemap.onboarding()} />;
  }

  return element;
};
